import React, { Component } from 'react';

import { isMobile, isEdge, isIOS, isSafari } from 'react-device-detect';
import classes from './Radio.module.css';

export default class Radio extends Component {
  state = { style: {} };

  componentDidMount () {
    // calculate dynamically and set font size for gender radio button
    const fontSize = this._calculateFontSize(isMobile, this.props.isLandscape, this.props.largerRadio);
    // set dynamical font size
    this.setState({ style: { fontSize } });
  }
  UNSAFE_componentWillReceiveProps (nextProp) {
    this.setState({ style: { fontSize: this._calculateFontSize(isMobile, nextProp.isLandscape, nextProp.largerRadio) } });
  }

  _getTextWidth = (text, font) => {
    var canvas = this._getTextWidth.canvas || (this._getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  }
  _calculateFontSize = (isMobile, isLandscape, largerRadio) => {
    let width = this.divElement.clientWidth;
    let textWidth = this._getTextWidth(this.props.longestText, isLandscape ? '400 0.625rem Helvetica' : '400 0.5rem Helvetica');
    const calcRatio = isMobile || !isLandscape ? 0.35 : 0.425;
    const calcFontSize = width / textWidth * calcRatio;
    let minFontSize;
    if (isLandscape) {
      minFontSize = largerRadio ? '0.625rem' : '0.75rem';
    } else {
      minFontSize = largerRadio ? '0.5rem' : '0.625rem';
    }
    if (isEdge || (isIOS && !isLandscape) || (isSafari && isLandscape)) {
      return minFontSize;
    } else if (!isLandscape && calcFontSize > 1) {
      return '1rem';
    } else if (calcFontSize > 1.5) {
      return '1.45rem';
    } else if (calcFontSize > 0.63) {
      return Math.round(calcFontSize * 1000) / 1000 + 'rem';
    } else {
      return minFontSize;
    }
  }

  render () {
    // console.log('//////// RADIO RENDERS ', this.props);
    let RadioWrapper = this.props.largerRadio ? classes.RadioWrapper : classes.RadioWrapperLarger;
    return (
      <div ref={(divElement) => { this.divElement = divElement }}>
        <div className={RadioWrapper} value={this.props.optionValue} onClick={this.props.radioClicked}>
          <div className={this.props.selected ? [classes.RadioCircle, classes.RadioCircleSelected].join(' ') : classes.RadioCircle}>
            <div className={classes.OptionNames} style={this.state.style}>{this.props.optionText}</div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/RadioGroupIcon/Radio/Radio.js